var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagestatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_529_1335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26069 1.58831L11.0403 4.29907C11.181 4.35532 11.3017 4.45245 11.3868 4.57794C11.4719 4.70343 11.5174 4.85153 11.5175 5.00313V17.7854C11.5173 17.9092 11.4867 18.0312 11.4286 18.1405C11.3704 18.2498 11.2863 18.3433 11.1837 18.4126C11.0811 18.482 10.9631 18.5252 10.84 18.5385C10.7168 18.5517 10.5923 18.5346 10.4773 18.4887L4.40787 16.0609C4.26721 16.0047 4.14659 15.9077 4.06154 15.7823C3.97649 15.657 3.93091 15.5091 3.93066 15.3576V2.21498C3.93066 2.01376 4.0106 1.82079 4.15288 1.67851C4.29516 1.53623 4.48813 1.4563 4.68934 1.4563H15.3109C15.5121 1.4563 15.7051 1.53623 15.8473 1.67851C15.9896 1.82079 16.0696 2.01376 16.0696 2.21498V15.1125C16.0696 15.2122 16.0499 15.3108 16.0118 15.4029C15.9737 15.4949 15.9178 15.5786 15.8473 15.649C15.7769 15.7195 15.6933 15.7754 15.6012 15.8135C15.5092 15.8516 15.4105 15.8712 15.3109 15.8712H13.7935",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34961 1.53687L13.1776 3.23403C13.3509 3.2672 13.5072 3.35974 13.6197 3.49572C13.7321 3.6317 13.7936 3.80261 13.7937 3.97906V16.6301C13.7937 16.8313 13.7137 17.0242 13.5715 17.1665C13.4292 17.3088 13.2362 17.3887 13.035 17.3887H11.5176",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_529_1335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagestatus);
export default __webpack_public_path__ + "static/media/pagestatus.215532b4866ad995e546902943c3f85c.svg";
export { ForwardRef as ReactComponent };